import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 'user', label: 'User' },
    { value: 'client', label: 'Client' },
  ],
});
